var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSprinkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.78342 20C9.78342 17.0043 4.76938 11.9903 1.77368 11.9903C4.76938 11.9903 9.78342 6.97622 9.78342 3.98053C9.78342 6.97622 14.7975 11.9903 17.7932 11.9903C14.7975 11.9903 9.78342 17.0043 9.78342 20Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.7835 15.1451C9.7835 13.9655 7.80822 11.9903 6.62866 11.9903C7.80822 11.9903 9.7835 10.015 9.7835 8.83542C9.7835 10.015 11.7588 11.9903 12.9383 11.9903C11.7582 11.9903 9.7835 13.9649 9.7835 15.1451Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.3679 8.83542C15.3679 7.3925 12.9526 4.97722 11.5097 4.97722C12.9526 4.97722 15.3679 2.56194 15.3679 1.11902C15.3679 2.56194 17.7832 4.97722 19.2261 4.97722C17.7832 4.97722 15.3679 7.3925 15.3679 8.83542ZM4.12655 19.7123C4.12655 18.969 2.88271 17.7251 2.1394 17.7251C2.88271 17.7251 4.12655 16.4813 4.12655 15.738C4.12655 16.4813 5.37038 17.7251 6.11369 17.7251C5.37038 17.7258 4.12655 18.9696 4.12655 19.7123ZM6.68974 5.51582C6.68974 4.48418 4.96347 2.75791 3.93183 2.75791C4.96347 2.75791 6.68974 1.03164 6.68974 0C6.68974 1.03164 8.41601 2.75791 9.44765 2.75791C8.41601 2.75791 6.68974 4.48418 6.68974 5.51582Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprinkle);
export default __webpack_public_path__ + "static/media/Sprinkle.ece45f6c7b67b20b9caca727b86658c6.svg";
export { ForwardRef as ReactComponent };